import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import {
  LayoutDashboard, ShoppingBag, ArrowRightLeft, Menu as MenuIcon,
  Sparkles, Users, FileText, Wallet, BarChart3, UserCog, Settings, CreditCard, ScanText, Package, Landmark,
} from "lucide-react";
import { DocScan } from "./DocScan";

const MORE = [
  { to: "/app/bestand", label: "Warenwirtschaft", icon: Package },
  { to: "/app/ki-import", label: "L19 KI", icon: Sparkles },
  { to: "/app/ankauf", label: "Ankaufshistorie", icon: ShoppingBag },
  { to: "/app/verkaeufer", label: "Verkäufer", icon: Users },
  { to: "/app/produkte", label: "Produkte", icon: Package },
  { to: "/app/kategorien", label: "Kategorien", icon: Package },
  { to: "/app/verkauf", label: "Verkäufe", icon: ArrowRightLeft },
  { to: "/app/rechnungen", label: "Rechnungen", icon: FileText },
  { to: "/app/kunden", label: "Kunden", icon: Users },
  { to: "/app/dokumente", label: "Dokumente", icon: FileText },
  { to: "/app/vertraege", label: "Verträge", icon: FileText },
  { to: "/app/finanzen", label: "Finanzen", icon: Wallet },
  { to: "/app/steuerberater", label: "Steuerberater", icon: Landmark },
  { to: "/app/auswertungen", label: "Auswertungen", icon: BarChart3 },
  { to: "/app/mitarbeiter", label: "Mitarbeiter", icon: UserCog },
  { to: "/app/einstellungen", label: "Einstellungen", icon: Settings },
  { to: "/app/abrechnung", label: "Abo & Abrechnung", icon: CreditCard },
];

function Item({ to, end, label, icon: Icon, testid }) {
  return (
    <NavLink to={to} end={end} data-testid={testid}
      className={({ isActive }) => `flex flex-col items-center gap-0.5 py-2 min-h-[56px] justify-center transition-colors ${isActive ? "text-zinc-900" : "text-zinc-400"}`}>
      <Icon className="w-5 h-5" />
      <span className="text-[10px] font-medium">{label}</span>
    </NavLink>
  );
}

export function BottomNav() {
  const [moreOpen, setMoreOpen] = useState(false);
  const [scanOpen, setScanOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <nav className="lg:hidden fixed bottom-0 inset-x-0 z-30 bg-white border-t border-zinc-200 safe-bottom" data-testid="bottom-nav">
        <div className="grid grid-cols-5">
          <Item to="/app" end label="Dashboard" icon={LayoutDashboard} testid="bottomnav-dashboard" />
          <Item to="/app/ankauf/neu" label="Ankauf" icon={ShoppingBag} testid="bottomnav-ankauf" />
          <button onClick={() => setScanOpen(true)} data-testid="bottomnav-scan"
            className="flex flex-col items-center justify-center gap-0.5 text-zinc-400 min-h-[56px]">
            <div className="w-11 h-11 -mt-6 bg-zinc-900 text-white rounded-full flex items-center justify-center shadow-lg border-4 border-white active:scale-95 transition-transform">
              <ScanText className="w-5 h-5" />
            </div>
            <span className="text-[10px] font-medium">Scannen</span>
          </button>
          <Item to="/app/verkauf/neu" label="Verkauf" icon={ArrowRightLeft} testid="bottomnav-verkauf" />
          <button onClick={() => setMoreOpen(true)} data-testid="bottomnav-more"
            className="flex flex-col items-center gap-0.5 py-2 min-h-[56px] justify-center text-zinc-400">
            <MenuIcon className="w-5 h-5" />
            <span className="text-[10px] font-medium">Mehr</span>
          </button>
        </div>
      </nav>

      <Sheet open={moreOpen} onOpenChange={setMoreOpen}>
        <SheetContent side="bottom" className="rounded-t-2xl max-h-[80vh] overflow-y-auto safe-bottom" data-testid="bottomnav-more-sheet">
          <SheetHeader><SheetTitle>Alle Bereiche</SheetTitle></SheetHeader>
          <div className="grid grid-cols-3 gap-2 mt-4 pb-6">
            {MORE.map((m) => (
              <button key={m.to} onClick={() => { setMoreOpen(false); navigate(m.to); }} data-testid={`more-nav-${m.label.toLowerCase().replace(/[^a-zäöü]/g, "-")}`}
                className="flex flex-col items-center gap-2 border border-zinc-200 rounded-xl p-4 hover:border-zinc-900 active:bg-zinc-50 transition-colors min-h-[72px]">
                <m.icon className="w-5 h-5 text-zinc-700" />
                <span className="text-xs font-medium text-center">{m.label}</span>
              </button>
            ))}
          </div>
        </SheetContent>
      </Sheet>

      <DocScan open={scanOpen} onClose={() => setScanOpen(false)} onSaved={() => navigate("/app/dokumente")} />
    </>
  );
}
